var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container", staticClass: "rb-board-with-fields-below" },
    [
      _c(
        "rb-smart-container",
        {
          attrs: {
            "full-screen-mobile": _vm.fullScreenMobile,
            "slides-per-view-desktop": _vm.slidesPerViewDesktopTest,
            "slides-per-view-mobile": _vm.slidesPerViewMobile,
            "slides-per-view-tablet": _vm.slidesPerViewTablet,
            "columns-of-next-slide": _vm.columnsOfNextSlideTest,
            "always-show-swiper": _vm.alwaysShowSwiper,
            pagination: _vm.hasPagination,
          },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }